import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import style from '../index.module.scss'

export const Header = () => {
  return (
    <>
      <div
        className={['dFlex justifyContentBetween', style.headerTitle].join(' ')}
      >
        <Element
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: '#0553A5',
            textTransform: 'uppercase',
          }}
        >
          <Translate value="connectMap.main.ENTITY_MAP" />
        </Element>
      </div>
    </>
  )
}
